import { InkwellGroup } from "./InkwellGroup";
import { ImagePanel } from "./ImagePanel";

const STEPS = [
  {
    title: "deploy + initialize v4",
    body: "Gaia.sol live on mainnet. Owner mints the seed Uniswap v4 position to the contract itself and registers it via setupV4(). Liquidity is locked from day one (no remove function exists).",
    tag: "now",
    accent: "from-teal-300 to-leaf",
  },
  {
    title: "open the mint",
    body: "Public mint at 0.001 ETH. Frontend + MCP go live the same day. Every fee splits 50/50 — half to the team, half to the LP buffer.",
    tag: "T+0",
    accent: "from-leaf to-teal-400",
  },
  {
    title: "first flushes",
    body: "Every 0.01 ETH (≈10 mints) emits LPFlushReady. A keeper batches the LP buffer into the v4 position. Liquidity grows in steady increments — visible on the chart.",
    tag: "ongoing",
    accent: "from-teal-400 to-sun",
  },
  {
    title: "team cap closes",
    body: "After 10,000 mints the team wallet has received its 5 ETH and stops. Forever. Every fee from then on is 100% LP.",
    tag: "phase 2",
    accent: "from-sun to-coral",
  },
  {
    title: "fee harvest",
    body: "claimFees() is permissionless. Anyone can sweep accrued v4 trading fees out to the team wallet — recurring revenue without ever touching principal.",
    tag: "always",
    accent: "from-coral to-rose",
  },
  {
    title: "low-supply NFT",
    body: "A small, hand-illustrated Earth-themed collection. GAIA holders mint first. Details closer to the date.",
    tag: "later",
    accent: "from-rose to-teal-300",
  },
];

export function Roadmap() {
  return (
    <section id="roadmap" className="relative px-5 md:px-10 py-24 md:py-32 max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 items-end mb-12">
        <ImagePanel
          src="/images/nails.jpg"
          alt="Wildlife moodboard — bear, deer, mountains, Yellowstone"
          className="hidden lg:block aspect-[3/4] max-h-96"
          filter="saturate(1.05) brightness(0.95)"
        />
        <div>
          <div className="eyebrow mb-4"><span className="dot" />roadmap</div>
          <h2 className="font-display text-5xl md:text-7xl tracking-tight leading-[0.95]">
            a small <span className="font-serif italic text-aurora">arc</span>.
          </h2>
          <p className="mt-6 text-bone-dim text-base max-w-2xl">
            Six steps. Most happen automatically once mints start.
          </p>
        </div>
      </div>

      <InkwellGroup className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {STEPS.map((s, i) => (
          <div key={i} className="ink-card p-6 md:p-7">
            <div className="flex items-center justify-between mb-4">
              <div className={`size-10 rounded-full bg-gradient-to-br ${s.accent} grid place-items-center font-mono text-ink-1000 text-sm font-bold`}>
                {i + 1}
              </div>
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-bone-dim">{s.tag}</span>
            </div>
            <div className="font-display text-2xl mb-2">{s.title}</div>
            <div className="text-bone-dim text-sm leading-relaxed">{s.body}</div>
          </div>
        ))}
      </InkwellGroup>
    </section>
  );
}
